import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { LineOAMembersTableDto } from '../../../models/lineOA.model';

export interface LineOaTableQuery {
  page?: number;
  pageSize?: number;
  searchField?: string;
  searchText?: string;
  language?: string;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc' | '';
}

@Injectable({
  providedIn: 'root',
})
export class ApiLineOaService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getUserLineOAForTable(query: LineOaTableQuery = {}): Observable<LineOAMembersTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.language && query.language !== 'all') params['language'] = query.language;
    if (query.sortColumn) params['sortColumn'] = query.sortColumn;
    if (query.sortDirection) params['sortDirection'] = query.sortDirection;

    return this.apiMethodService.request<LineOAMembersTableDto>(
      '/backoffice/getUserLineOAForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getUserLineOAForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }
}
